import { AsyncPipe, DecimalPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { DerivativeSearchFacade, ISSUER_MAPPING } from '@zero/leverage-products/domain';
import { OpenEndPipe } from '@zero/shared/ui-pipes';
import { DerivativeSearchProduct } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';
import { TrackingQueryParamsPipe } from '../../pipes/tracking-query-params/tracking-query-params.pipe';

@Component({
  selector: 'leverage-products-derivative-search-list',
  templateUrl: './derivative-search-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, AsyncPipe, DecimalPipe, TranslocoPipe, OpenEndPipe, NgTemplateOutlet, TrackingQueryParamsPipe],
  styleUrls: ['./derivative-search-list.component.scss'],
})
export class DerivativeSearchListComponent {
  @Input() public products: DerivativeSearchProduct[];

  public readonly orderMask = commonRoutes.postlogin.buyAndSell;
  public readonly instrumentDetail = commonRoutes.postlogin.instrument_detail;
  public readonly facade = inject(DerivativeSearchFacade);
  public readonly ISSUER_MAPPING = ISSUER_MAPPING;
}
